import React from 'react';
import { Shield, Heart } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="mt-20 border-t border-white/10 bg-[#07080C] text-slate-400 py-12 pb-28 lg:pb-12 transition-colors">
      <div className="container mx-auto px-4 sm:px-6 max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 pb-10 border-b border-white/5">
          {/* Brand Column */}
          <div className="md:col-span-1 space-y-4">
            <div className="flex items-center gap-2">
           
              <span className="text-2xl font-extrabold text-white font-display">
                Binge<span className="text-orange-500">HQ</span>
              </span>
            </div>
            <p className="text-sm text-slate-400 max-w-md leading-relaxed">
              Dive into endless hours of free streaming entertainment with BingeHQ! Your ultimate hub for movies, TV series, and live broadcasting.
            </p>
            {/* System Status Pill */}
            {/* <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-emerald-500/10 border border-emerald-500/20 text-emerald-400 text-xs font-semibold">
              <span className="w-2 h-2 rounded-full bg-emerald-400 animate-pulse"></span>
              All Streaming Servers Operational
            </div> */}
          </div>


          {/* Trust / Transparency */}
          <div className="space-y-3">
            <h4 className="text-xs font-bold uppercase tracking-wider text-slate-200">Legal & Disclaimer</h4>
            <div className="flex items-start gap-2 text-xs text-slate-400 leading-relaxed bg-white/5 p-3 rounded-2xl border border-white/5">
              <Shield size={16} className="text-orange-400 flex-shrink-0 mt-0.5" />
              <span>
                BingeHQ does not host or store media files on its servers. All streams are embedded from public third-party sources.
              </span>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-6 flex flex-col sm:flex-row items-center justify-between text-xs text-slate-500 gap-4">
          <p>© {new Date().getFullYear()} BingeHQ Inc. Built for binge-watchers everywhere.</p>
          <div className="flex items-center gap-1">
            Crafted with <Heart size={13} className="text-red-500 fill-red-500 mx-0.5" /> for smooth streaming
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;